import { render, staticRenderFns } from "./OpenidLogin.vue?vue&type=template&id=16f97ee4&scoped=true"
import script from "./OpenidLogin.vue?vue&type=script&lang=js"
export * from "./OpenidLogin.vue?vue&type=script&lang=js"
import style0 from "./OpenidLogin.vue?vue&type=style&index=0&id=16f97ee4&prod&lang=scss"
import style1 from "./OpenidLogin.vue?vue&type=style&index=1&id=16f97ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f97ee4",
  null
  
)

export default component.exports